module.exports = __webpack_public_path__ + "img/24.e1dc7534.png";